// @ts-nocheck
/* eslint-disable */

  /**
  * Do not change! File was auto generate. 
  *
  */
  
import React from 'react';

import { ReactComponent as ChevronLeftComponent} from './ChevronLeft.svg';

import Icon, { TIconProps } from '../Icon';

export const IconChevronLeft = React.forwardRef<any, TIconProps>((props, ref) => (
  <Icon
    ref={ref}
    {...props}
  >
    <ChevronLeftComponent/>
  </Icon>
));
